export default __webpack_public_path__ + "static/media/right_arrow.0074ba88.svg";